/*
import {
  getByDictValue, getValue, getConfigValue
} from '@/zsm-api/dict.js' */

import {
  sendMsgSms
} from "@/zsm-api-new/sms.js"
import {getTemplate,templateListData,labelListData,classifyListData,settingConfig,ossUploadToken,settingDict} from "@/zsm-api-new/dict.js"
const state = {

}

const mutations = {

}

const actions = {
  // 查看模板列表
   templateListData({
     commit
   }) {
     return new Promise((resolve, reject) => {
       templateListData().then(response => {
           resolve(response)
       }).catch(error => {
         reject(error)
       })
     })
   },
 // 查看一个模板
  getTemplate({
    commit
  },id) {
    return new Promise((resolve, reject) => {
      getTemplate(id).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取标签列表
  labelListData({
    commit
  }) {
    return new Promise((resolve, reject) => {
      labelListData().then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取课程分类
  classifyListData({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      classifyListData(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发送验证码
  sendMsgSms({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      let {mobile,msgDict} =info
      sendMsgSms(mobile,msgDict).then(response => {
          resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取七牛云上传文件的token
  ossUploadToken({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      let {filePath,title} =info
      ossUploadToken(filePath,title).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 字典管理-获取某个字典的所有值的集合
  settingDict({
    commit
  }, dictType) {
    return new Promise((resolve, reject) => {
      settingDict(dictType).then(response => {
          resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

 /* 参数设置-获取特定key对应的value */
  settingConfig({
    commit
  }, dictType) {
    return new Promise((resolve, reject) => {
      settingConfig(dictType).then(response => {
          resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },





  /* //  获取后台配置字典
  getByDictValueList({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getByDictValue(dictValue).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //  获取后台配置字典
  getValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfigValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getConfigValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  } */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
